module.exports = __webpack_public_path__ + "img/download_banner_mobile.6b738f16.png";